/* global axios */
import ApiClient from "./ApiClient";

class AssistantToolsAPI extends ApiClient {
  constructor() {
    super("assistant_tools", { accountScoped: true });
  }

  // Get all tools
  getTools() {
    return axios.get(this.url);
  }

  // Get tool types
  getTypes() {
    return axios.get(`${this.url}/types`);
  }

  // Get single tool
  getTool(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // Create new tool
  createTool(toolData) {
    return axios.post(this.url, {
      type: this.mapPurposeToType(toolData.purpose),
      title: toolData.name,
      url: toolData.url || '#',
      description: toolData.description,
      metadata: {
        purpose: toolData.purpose,
        size: toolData.size,
        original_name: toolData.name
      }
    });
  }

  // Update tool
  updateTool(id, toolData) {
    return axios.put(`${this.url}/${id}`, {
      type: this.mapPurposeToType(toolData.purpose),
      title: toolData.name,
      url: toolData.url || '#',
      description: toolData.description,
      metadata: {
        purpose: toolData.purpose,
        size: toolData.size || 0,
        original_name: toolData.name
      },
      // Incluir asignación de asistente si está presente
      assistant_ids: toolData.assistantIds || []
    });
  }

  // Assign tool to assistant
  assignToAssistant(toolId, assistantId) {
    return axios.post(`${this.url}/${toolId}/assign`, {
      assistant_id: assistantId
    });
  }

  // Unassign tool from assistant
  unassignFromAssistant(toolId, assistantId) {
    return axios.delete(`${this.url}/${toolId}/assign`, {
      data: { assistant_id: assistantId }
    });
  }

  // Delete tool
  deleteTool(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Helper method to map purpose to API type
  mapPurposeToType(purpose) {
    const purposeTypeMap = {
      'Documentación': 'file',
      'Análisis': 'file',
      'Entrenamiento': 'file', 
      'Referencia': 'web_page',
      'Configuración': 'file',
      'Personalizado': 'other'
    };
    return purposeTypeMap[purpose] || 'other';
  }

  // Helper method to transform API response to component format
  transformApiResponse(apiTool) {
    return {
      id: apiTool.id,
      name: apiTool.metadata?.original_name || apiTool.title,
      size: apiTool.metadata?.size || 0,
      purpose: apiTool.metadata?.purpose || 'Personalizado',
      createdAt: apiTool.created_at,
      status: 'active', // Default status
      fileId: apiTool.id,
      description: apiTool.description,
      url: apiTool.url !== '#' ? apiTool.url : null,
      type: apiTool.type,
      metadata: apiTool.metadata,
      // Información del asistente asignado
      assignedAssistant: apiTool.ai_assistants && apiTool.ai_assistants.length > 0 ? apiTool.ai_assistants[0] : null,
      assistantIds: apiTool.ai_assistants ? apiTool.ai_assistants.map(a => a.id) : []
    };
  }
}

export default new AssistantToolsAPI();
